// extracted by mini-css-extract-plugin
module.exports = {"title":"TopSongs_title__3bo2I","song":"TopSongs_song__3THwc"};